// generated by genversion
export const version = '1.2.4';
